// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODERN NAVIGATION BAR
   ============================================ */

:root {
  --nav-height: 95px;
  --nav-bg: #ffffff;
  --nav-text: #0d141b;
  --nav-text-hover: #0d47a1;
  --nav-active: #0d47a1;
  --nav-border: #e2e8f0;
  --nav-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
  --nav-transition: all 0.3s ease;
  --nav-orange: #f97316;
  --nav-green: #16a34a;
}

/* ============================================
   MAIN NAVIGATION
   ============================================ */

.nav {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: var(--nav-height);
  background: var(--nav-bg);
  border-bottom: 1px solid transparent;
  z-index: 1000;
  transition: var(--nav-transition);
}

.nav--scrolled {
  border-bottom-color: var(--nav-border);
  box-shadow: var(--nav-shadow);
}

.nav__container {
  max-width: 1800px;
  height: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

@media (min-width: 1400px) {
  .nav__container {
    padding: 0 3rem;
    gap: 2.5rem;
  }
}

@media (min-width: 1600px) {
  .nav__container {
    padding: 0 4rem;
    gap: 3rem;
  }
}

/* ============================================
   LOGO
   ============================================ */

.nav__logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.nav__logo-img {
  height: 85px;
  width: auto;
  display: block;
}

/* ============================================
   DESKTOP MENU
   ============================================ */

.nav__menu {
  display: none;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  justify-content: center;
  max-width: 1200px;
}

@media (min-width: 1100px) {
  .nav__menu {
    display: flex;
  }
}

.nav__link {
  position: relative;
  padding: 0.7rem 0.85rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--nav-text);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.nav__link:hover {
  color: var(--nav-text-hover);
  background: rgba(13, 71, 161, 0.06);
  transform: translateY(-1px);
}

.nav__link--active {
  color: var(--nav-active);
  background: linear-gradient(135deg, rgba(13, 71, 161, 0.1) 0%, rgba(13, 71, 161, 0.15) 100%);
  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.15);
}

/* Sathi Link with Icon - GREEN */
.nav__link--sathi {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
  border: 2px solid #bbf7d0 !important;
  color: #16a34a !important;
  font-weight: 700;
  box-shadow: none !important;
  padding: 0.6rem 1.5rem 0.6rem 1rem !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
}

.nav__link--sathi::after {
  display: none !important;
  content: none !important;
}

.nav__link--sathi:hover {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;
  border-color: #86efac !important;
  color: #15803d !important;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25) !important;
}

.nav__sathi-icon {
  height: 20px;
  width: auto;
  flex-shrink: 0;
}

/* ============================================
   RIGHT ACTIONS
   ============================================ */

.nav__actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

@media (min-width: 1400px) {
  .nav__actions {
    gap: 1rem;
  }
}

/* Login Button - PURPLE */
.nav__btn {
  display: none;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(55, 11, 59, 0.3);
  white-space: nowrap;
}

@media (min-width: 1100px) {
  .nav__btn {
    display: inline-block;
  }
}

.nav__btn:hover {
  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);
}

/* Course Launch Button - ORANGE/ACCENT */
.nav__launch-btn {
  display: none;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
  text-decoration: none;
  border: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  white-space: nowrap;
  cursor: pointer;
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  }
  50% {
    box-shadow: 0 4px 16px rgba(249, 115, 22, 0.5), 0 0 20px rgba(249, 115, 22, 0.2);
  }
}

@media (min-width: 1100px) {
  .nav__launch-btn {
    display: inline-block;
  }
}

.nav__launch-btn:hover {
  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);
  animation: none;
}

/* Call Button - GREEN */
.nav__call-btn {
  display: none;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  text-decoration: none;
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
  white-space: nowrap;
}

.nav__call-btn::after {
  display: none !important;
  content: none !important;
}

@media (min-width: 1100px) {
  .nav__call-btn {
    display: flex;
  }
}

.nav__call-btn:hover {
  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.4);
}

.nav__call-icon {
  width: 18px;
  height: 18px;
}

/* Remove old phone number styles */
.nav__phone {
  display: none !important;
}

.nav__phone-text {
  white-space: nowrap;
}

/* Hamburger Menu */
.nav__hamburger {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 10;
}

@media (min-width: 1100px) {
  .nav__hamburger {
    display: none;
  }
}

.nav__hamburger span {
  width: 24px;
  height: 2.5px;
  background: var(--nav-text);
  border-radius: 2px;
  transition: var(--nav-transition);
}

.nav__hamburger:hover span {
  background: var(--nav-text-hover);
}

/* ============================================
   MOBILE MENU
   ============================================ */

.nav__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9998;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.nav__mobile {
  position: fixed;
  top: 0;
  right: -100%;
  bottom: 0;
  width: 320px;
  max-width: 85vw;
  background: #ffffff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease;
}

.nav__mobile--open {
  right: 0;
}

.nav__mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--nav-border);
}

.nav__mobile-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  font-size: 1.5rem;
  color: var(--nav-text);
  cursor: pointer;
  transition: var(--nav-transition);
}

.nav__mobile-close:hover {
  background: #e2e8f0;
  color: #ef4444;
}

.nav__mobile-links {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
}

.nav__mobile-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--nav-text);
  text-decoration: none;
  border-left: 3px solid transparent;
  transition: var(--nav-transition);
}

.nav__mobile-link:hover {
  background: rgba(13, 71, 161, 0.05);
  color: var(--nav-text-hover);
  border-left-color: var(--nav-text-hover);
}

.nav__mobile-link--active {
  background: rgba(13, 71, 161, 0.08);
  color: var(--nav-active);
  border-left-color: var(--nav-active);
}

.nav__mobile-link--sathi {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
  border-left-color: #16a34a !important;
  color: #16a34a !important;
}

.nav__mobile-footer {
  padding: 1.5rem;
  border-top: 1px solid var(--nav-border);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.nav__mobile-btn {
  display: block;
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(55, 11, 59, 0.3);
}

.nav__mobile-btn:hover {
  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);
}

/* Mobile Course Launch Button */
.nav__mobile-launch-btn {
  display: block;
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
  text-decoration: none;
  border: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  cursor: pointer;
  animation: pulse-glow 2s ease-in-out infinite;
}

.nav__mobile-launch-btn:hover {
  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);
  animation: none;
}

.nav__mobile-phone {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #16a34a;
  text-decoration: none;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px solid #bbf7d0;
  border-radius: 10px;
  transition: var(--nav-transition);
}

.nav__mobile-phone:hover {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  border-color: #86efac;
  transform: translateY(-1px);
}

/* ============================================
   RESPONSIVE ADJUSTMENTS
   ============================================ */

@media (max-width: 768px) {
  .nav__container {
    padding: 0 1.5rem;
  }

  .nav__logo-img {
    height: 60px;
  }

  .nav__mobile {
    width: 280px;
  }
}

@media (max-width: 480px) {
  .nav__container {
    padding: 0 1rem;
  }

  .nav__logo-img {
    height: 45px;
  }

  .nav__mobile {
    width: 100%;
    max-width: 100vw;
  }
}

/* ============================================
   DARK MODE SUPPORT (OPTIONAL)
   ============================================ */

html[data-theme="dark"] .nav {
  --nav-bg: #0f172a;
  --nav-text: #e2e8f0;
  --nav-text-hover: #60a5fa;
  --nav-active: #3b82f6;
  --nav-border: #1e293b;
}

html[data-theme="dark"] .nav__mobile {
  background: #0f172a;
}

html[data-theme="dark"] .nav__mobile-close {
  background: #1e293b;
  color: #e2e8f0;
}

html[data-theme="dark"] .nav__mobile-close:hover {
  background: #334155;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Navigation/navigation.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;EAC5C,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4FAA4F;EAC5F,6CAA6C;AAC/C;;AAEA,iCAAiC;AACjC;EACE,wEAAwE;EACxE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,6CAA6C;EAC7C,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,8CAA8C;EAC9C,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,gFAAgF;EAClF;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,iCAAiC;EACjC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,8CAA8C;EAC9C,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================================\r\n   MODERN NAVIGATION BAR\r\n   ============================================ */\r\n\r\n:root {\r\n  --nav-height: 95px;\r\n  --nav-bg: #ffffff;\r\n  --nav-text: #0d141b;\r\n  --nav-text-hover: #0d47a1;\r\n  --nav-active: #0d47a1;\r\n  --nav-border: #e2e8f0;\r\n  --nav-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);\r\n  --nav-transition: all 0.3s ease;\r\n  --nav-orange: #f97316;\r\n  --nav-green: #16a34a;\r\n}\r\n\r\n/* ============================================\r\n   MAIN NAVIGATION\r\n   ============================================ */\r\n\r\n.nav {\r\n  position: sticky;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: var(--nav-height);\r\n  background: var(--nav-bg);\r\n  border-bottom: 1px solid transparent;\r\n  z-index: 1000;\r\n  transition: var(--nav-transition);\r\n}\r\n\r\n.nav--scrolled {\r\n  border-bottom-color: var(--nav-border);\r\n  box-shadow: var(--nav-shadow);\r\n}\r\n\r\n.nav__container {\r\n  max-width: 1800px;\r\n  height: 100%;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .nav__container {\r\n    padding: 0 3rem;\r\n    gap: 2.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .nav__container {\r\n    padding: 0 4rem;\r\n    gap: 3rem;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   LOGO\r\n   ============================================ */\r\n\r\n.nav__logo {\r\n  display: flex;\r\n  align-items: center;\r\n  text-decoration: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav__logo-img {\r\n  height: 85px;\r\n  width: auto;\r\n  display: block;\r\n}\r\n\r\n/* ============================================\r\n   DESKTOP MENU\r\n   ============================================ */\r\n\r\n.nav__menu {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex: 1;\r\n  justify-content: center;\r\n  max-width: 1200px;\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .nav__menu {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.nav__link {\r\n  position: relative;\r\n  padding: 0.7rem 0.85rem;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--nav-text);\r\n  text-decoration: none;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  white-space: nowrap;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.nav__link:hover {\r\n  color: var(--nav-text-hover);\r\n  background: rgba(13, 71, 161, 0.06);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.nav__link--active {\r\n  color: var(--nav-active);\r\n  background: linear-gradient(135deg, rgba(13, 71, 161, 0.1) 0%, rgba(13, 71, 161, 0.15) 100%);\r\n  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.15);\r\n}\r\n\r\n/* Sathi Link with Icon - GREEN */\r\n.nav__link--sathi {\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;\r\n  border: 2px solid #bbf7d0 !important;\r\n  color: #16a34a !important;\r\n  font-weight: 700;\r\n  box-shadow: none !important;\r\n  padding: 0.6rem 1.5rem 0.6rem 1rem !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  gap: 0.5rem !important;\r\n}\r\n\r\n.nav__link--sathi::after {\r\n  display: none !important;\r\n  content: none !important;\r\n}\r\n\r\n.nav__link--sathi:hover {\r\n  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;\r\n  border-color: #86efac !important;\r\n  color: #15803d !important;\r\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25) !important;\r\n}\r\n\r\n.nav__sathi-icon {\r\n  height: 20px;\r\n  width: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ============================================\r\n   RIGHT ACTIONS\r\n   ============================================ */\r\n\r\n.nav__actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .nav__actions {\r\n    gap: 1rem;\r\n  }\r\n}\r\n\r\n/* Login Button - PURPLE */\r\n.nav__btn {\r\n  display: none;\r\n  padding: 0.7rem 1.25rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);\r\n  text-decoration: none;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  box-shadow: 0 4px 12px rgba(55, 11, 59, 0.3);\r\n  white-space: nowrap;\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .nav__btn {\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.nav__btn:hover {\r\n  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);\r\n}\r\n\r\n/* Course Launch Button - ORANGE/ACCENT */\r\n.nav__launch-btn {\r\n  display: none;\r\n  padding: 0.7rem 1.25rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\r\n  text-decoration: none;\r\n  border: none;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  animation: pulse-glow 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pulse-glow {\r\n  0%, 100% {\r\n    box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\r\n  }\r\n  50% {\r\n    box-shadow: 0 4px 16px rgba(249, 115, 22, 0.5), 0 0 20px rgba(249, 115, 22, 0.2);\r\n  }\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .nav__launch-btn {\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.nav__launch-btn:hover {\r\n  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);\r\n  animation: none;\r\n}\r\n\r\n/* Call Button - GREEN */\r\n.nav__call-btn {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.7rem 1.25rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);\r\n  white-space: nowrap;\r\n}\r\n\r\n.nav__call-btn::after {\r\n  display: none !important;\r\n  content: none !important;\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .nav__call-btn {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.nav__call-btn:hover {\r\n  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.4);\r\n}\r\n\r\n.nav__call-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n/* Remove old phone number styles */\r\n.nav__phone {\r\n  display: none !important;\r\n}\r\n\r\n.nav__phone-text {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Hamburger Menu */\r\n.nav__hamburger {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  background: none;\r\n  border: none;\r\n  padding: 0.5rem;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .nav__hamburger {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.nav__hamburger span {\r\n  width: 24px;\r\n  height: 2.5px;\r\n  background: var(--nav-text);\r\n  border-radius: 2px;\r\n  transition: var(--nav-transition);\r\n}\r\n\r\n.nav__hamburger:hover span {\r\n  background: var(--nav-text-hover);\r\n}\r\n\r\n/* ============================================\r\n   MOBILE MENU\r\n   ============================================ */\r\n\r\n.nav__overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(4px);\r\n  z-index: 9998;\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.nav__mobile {\r\n  position: fixed;\r\n  top: 0;\r\n  right: -100%;\r\n  bottom: 0;\r\n  width: 320px;\r\n  max-width: 85vw;\r\n  background: #ffffff;\r\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);\r\n  z-index: 9999;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: right 0.3s ease;\r\n}\r\n\r\n.nav__mobile--open {\r\n  right: 0;\r\n}\r\n\r\n.nav__mobile-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1.25rem 1.5rem;\r\n  border-bottom: 1px solid var(--nav-border);\r\n}\r\n\r\n.nav__mobile-close {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #f1f5f9;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1.5rem;\r\n  color: var(--nav-text);\r\n  cursor: pointer;\r\n  transition: var(--nav-transition);\r\n}\r\n\r\n.nav__mobile-close:hover {\r\n  background: #e2e8f0;\r\n  color: #ef4444;\r\n}\r\n\r\n.nav__mobile-links {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.nav__mobile-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.875rem 1.5rem;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--nav-text);\r\n  text-decoration: none;\r\n  border-left: 3px solid transparent;\r\n  transition: var(--nav-transition);\r\n}\r\n\r\n.nav__mobile-link:hover {\r\n  background: rgba(13, 71, 161, 0.05);\r\n  color: var(--nav-text-hover);\r\n  border-left-color: var(--nav-text-hover);\r\n}\r\n\r\n.nav__mobile-link--active {\r\n  background: rgba(13, 71, 161, 0.08);\r\n  color: var(--nav-active);\r\n  border-left-color: var(--nav-active);\r\n}\r\n\r\n.nav__mobile-link--sathi {\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;\r\n  border-left-color: #16a34a !important;\r\n  color: #16a34a !important;\r\n}\r\n\r\n.nav__mobile-footer {\r\n  padding: 1.5rem;\r\n  border-top: 1px solid var(--nav-border);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.nav__mobile-btn {\r\n  display: block;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  background: linear-gradient(135deg, #370b3b 0%, #5a1761 100%);\r\n  text-decoration: none;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  box-shadow: 0 4px 12px rgba(55, 11, 59, 0.3);\r\n}\r\n\r\n.nav__mobile-btn:hover {\r\n  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(55, 11, 59, 0.4);\r\n}\r\n\r\n/* Mobile Course Launch Button */\r\n.nav__mobile-launch-btn {\r\n  display: block;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\r\n  text-decoration: none;\r\n  border: none;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\r\n  cursor: pointer;\r\n  animation: pulse-glow 2s ease-in-out infinite;\r\n}\r\n\r\n.nav__mobile-launch-btn:hover {\r\n  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);\r\n  animation: none;\r\n}\r\n\r\n.nav__mobile-phone {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.6rem;\r\n  padding: 1rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #16a34a;\r\n  text-decoration: none;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\r\n  border: 2px solid #bbf7d0;\r\n  border-radius: 10px;\r\n  transition: var(--nav-transition);\r\n}\r\n\r\n.nav__mobile-phone:hover {\r\n  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);\r\n  border-color: #86efac;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE ADJUSTMENTS\r\n   ============================================ */\r\n\r\n@media (max-width: 768px) {\r\n  .nav__container {\r\n    padding: 0 1.5rem;\r\n  }\r\n\r\n  .nav__logo-img {\r\n    height: 60px;\r\n  }\r\n\r\n  .nav__mobile {\r\n    width: 280px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .nav__container {\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .nav__logo-img {\r\n    height: 45px;\r\n  }\r\n\r\n  .nav__mobile {\r\n    width: 100%;\r\n    max-width: 100vw;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   DARK MODE SUPPORT (OPTIONAL)\r\n   ============================================ */\r\n\r\nhtml[data-theme=\"dark\"] .nav {\r\n  --nav-bg: #0f172a;\r\n  --nav-text: #e2e8f0;\r\n  --nav-text-hover: #60a5fa;\r\n  --nav-active: #3b82f6;\r\n  --nav-border: #1e293b;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .nav__mobile {\r\n  background: #0f172a;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .nav__mobile-close {\r\n  background: #1e293b;\r\n  color: #e2e8f0;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .nav__mobile-close:hover {\r\n  background: #334155;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
